import {makeExcelRouter} from "@/router/index.excel";
import {makeGraphiteRouter} from "@/router/index.graphite";
import {isExcel} from "@/utils/excel";

export const router = isExcel ? makeExcelRouter() : makeGraphiteRouter();
